<ng-container *ngIf="searchPressed && !displayProgressSpinner && !recordsFound(); else searchResults">
  <div class="flex-child--full-width">
    {{ 'no.records.available' | translate | async }}
  </div>
</ng-container>

<ng-template #searchResults>
  <div *ngFor="let record of dataSource">
    <div role="article" tabindex="0" aria-posinset="1" aria-setsize="20">
      <div class="row">
        <div class="col-12">

          <ng-container *ngIf="isAssessment(record)">
            <app-assessment-result-card [record]="record" [searchTerm]="this.searchTerm"></app-assessment-result-card>
          </ng-container>

          <ng-container *ngIf="isAssessmentPdf(record)">
            <app-assessment-pdf-result-card [record]="record" [searchTerm]="this.searchTerm"></app-assessment-pdf-result-card>
          </ng-container>
  
          <ng-container *ngIf="isDrillHole(record)">
            <app-drill-hole-result-card [record]="record" [searchTerm]="this.searchTerm"></app-drill-hole-result-card>
          </ng-container>
  
          <ng-container *ngIf="isPublication(record)">
            <app-publication-result-card [record]="record" [searchTerm]="this.searchTerm"></app-publication-result-card>
          </ng-container>

          <ng-container *ngIf="isPublicationPdf(record)">
            <app-publication-pdf-result-card [record]="record" [searchTerm]="this.searchTerm"></app-publication-pdf-result-card>
          </ng-container>
  
          <ng-container *ngIf="isMineralInventory(record)">
            <app-mineral-inventory-result-card [record]="record" [searchTerm]="this.searchTerm"></app-mineral-inventory-result-card>
          </ng-container>
          
          <ng-container *ngIf="isAbandonedMine(record)">
            <app-abandoned-mine-result-card [record]="record" [searchTerm]="this.searchTerm"></app-abandoned-mine-result-card>
          </ng-container>
          
        </div>
      </div>
    </div>
  </div>
</ng-template>